module.exports = __webpack_public_path__ + "img/souriredulac-presentation-.4fc4388f.png";